import type { IThemeColors } from '@anywayseo/tools';
import type { ThemeConfig as IThemeConfig, StyleFunctionProps } from '@chakra-ui/react';
import type { Styles } from '@chakra-ui/theme-tools';

import { extendTheme } from '@chakra-ui/react';

import { extractTheme, generateColorPalette } from './utils';


const initialColorMode = extractTheme(process.env.GATSBY_SITE_THEME);
const primaryColor = generateColorPalette(process.env.GATSBY_SITE_PRIMARY_COLOR);

const config: IThemeConfig = {
  initialColorMode,
};

const colors: IThemeColors = {
  brand: primaryColor,
};

const styles: Styles = {
  global: (props: StyleFunctionProps) => ({
    body: {
      width: '100vw',
      overflowX: 'hidden',
    },
    'ol, ul': {
      paddingLeft: 4,
    },
  }),
};

const theme = extendTheme({ config, colors, styles });

export default theme;
